import { CSSProperties, FC } from 'react';
import { Box } from '@mui/material';
import { Colors } from '../utils/Theme';

interface Props {
  message: string;
  style?: CSSProperties;
}

export const ErrorMessage: FC<Props> = ({ message, style }) => {
  return (
    <Box
      style={style}
      sx={{ marginTop: '16px', backgroundColor: Colors.SECONDARY_COLOR, color: '#fff', padding: '14px', fontSize: '14px', fontWeight: 500 }}
      data-testid="error-message"
    >
      {message}
    </Box>
  );
};
